import { Column as PrimeColumn } from 'primereact/column'

const Column = PrimeColumn

export default Column
